import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUI } from "@/context/UIContext";
import { Play, Plus, Check, Film, Volume2, VolumeX, Info } from "lucide-react";

export function HeroBillboard({ item }) {
  const navigate = useNavigate();
  const { openDetail, myListIds, toggleMyList } = useUI();
  const [muted, setMuted] = useState(true);
  if (!item) return null;
  const inList = myListIds.has(item.id);

  return (
    <div className="relative h-[78vh] md:h-[88vh] w-full">
      <img src={item.backdrop} alt={item.title} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 nik-scrim" />
      <div className="absolute inset-0 nik-scrim-left" />

      <div className="relative h-full flex flex-col justify-end pb-20 md:pb-28 px-4 md:px-12 max-w-2xl fade-up">
        {item.is_original && (
          <div className="flex items-center gap-2 mb-4">
            <span className="text-[var(--nik-gold)] font-display font-extrabold tracking-[0.25em] text-sm">K</span>
            <span className="text-slate-200 tracking-[0.35em] text-xs font-semibold">KALAMPRIME ORIGINAL</span>
          </div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight text-white">
          {item.title}
        </h1>
        <div className="flex items-center gap-3 mt-4 text-sm text-slate-300">
          {item.match > 0 && <span className="text-[var(--nik-glow)] font-bold font-mono">{item.match}% Match</span>}
          <span>{item.year}</span>
          <span className="border border-white/30 px-1.5 rounded text-xs">{item.rating}</span>
          <span className="text-slate-400">{item.genres?.slice(0, 2).join(" • ")}</span>
        </div>
        <p className="mt-4 text-sm sm:text-base text-slate-200 leading-relaxed line-clamp-3 max-w-xl">
          {item.description}
        </p>

        <div className="flex items-center gap-3 mt-7 flex-wrap">
          <button
            data-testid="hero-watch-now-button"
            onClick={() => navigate(`/watch/${item.id}`)}
            className="flex items-center gap-2 bg-white text-black font-semibold px-6 md:px-8 py-3 rounded-lg hover:bg-slate-200 transition-colors"
          >
            <Play size={20} fill="currentColor" /> Watch Now
          </button>
          <button
            data-testid="hero-trailer-button"
            onClick={() => navigate(`/watch/${item.id}?trailer=1`)}
            className="flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 text-white font-semibold px-5 md:px-6 py-3 rounded-lg hover:bg-white/20 transition-colors"
          >
            <Film size={19} /> Trailer
          </button>
          <button
            data-testid="hero-my-list-button"
            onClick={() => toggleMyList(item)}
            title="My List"
            className="w-12 h-12 rounded-full border border-white/30 text-white flex items-center justify-center hover:border-white bg-black/30 transition-colors"
          >
            {inList ? <Check size={22} /> : <Plus size={22} />}
          </button>
          <button
            onClick={() => openDetail(item)}
            title="More Info"
            className="w-12 h-12 rounded-full border border-white/30 text-white flex items-center justify-center hover:border-white bg-black/30 transition-colors"
          >
            <Info size={22} />
          </button>
        </div>
      </div>

      <button
        onClick={() => setMuted((m) => !m)}
        className="absolute bottom-24 md:bottom-32 right-4 md:right-12 w-11 h-11 rounded-full border border-white/40 text-white flex items-center justify-center bg-black/30 hover:border-white transition-colors"
      >
        {muted ? <VolumeX size={19} /> : <Volume2 size={19} />}
      </button>
    </div>
  );
}
